import { Component, signal } from '@angular/core';

@Component({
  selector: 'fini-login-mosaic',
  templateUrl: './login-mosaic.component.html',
  styleUrls: ['./login-mosaic.component.scss'],
  standalone: false,
})
export class LoginMosaicComponent {
  items: any[] = [];
  loaded = signal(false);

  observer: IntersectionObserver;
  ngOnInit(): void {
    const sizes = ['200', '400', '800', '1200', 'unscaled'];
    this.items = new Array(16).fill(0).map((_, i) => {
      const avif_sources = sizes.map(
        (size) =>
          `/assets/img/ui-prev/size-${size}/avif/ui-preview-${i + 1}.avif${size !== 'unscaled' ? ` ${parseInt(size) / 200}x` : ''}`,
      );
      const webp_sources = sizes.map(
        (size) =>
          `/assets/img/ui-prev/size-${size}/webp/ui-preview-${i + 1}.webp${size !== 'unscaled' ? ` ${parseInt(size) / 200}x` : ''}`,
      );
      const png_sources = sizes.map(
        (size) =>
          `/assets/img/ui-prev/size-${size}/png/ui-preview-${i + 1}.png${size !== 'unscaled' ? ` ${parseInt(size) / 200}x` : ''}`,
      );
      return {
        title: `Item ${i + 1}`,
        srcset: [avif_sources, webp_sources, png_sources],
        srcset_fmt: [
          avif_sources.join(', '),
          webp_sources.join(', '),
          png_sources.join(', '),
        ],
      };
    });
  }
  ngAfterViewInit(): void {
    setTimeout(() => this.loaded.set(true), 100);
  }
}
